import React from 'react'

interface FlexDivProps {
    id?: string
    direction?: 'column' | 'row'
    style?: React.CSSProperties
    className?: string
    onClick?: () => void
    children?: React.ReactNode
    ref?: React.RefObject<HTMLDivElement>
}

export const FlexDiv: React.FC<FlexDivProps> = (props) => {
    return (
        <div
            id={props.id}
            ref={props.ref}
            className={props.className}
            style={{
                display: 'flex',
                flexDirection: props.direction,
                ...props.style,
            }}
            onClick={() => {
                props.onClick && props.onClick()
            }}
        >
            {props.children}
        </div>
    )
}
